import { contactPublicFieldSchema } from '@/lib/form-schema';

export type ContactPhase =
  | 'idle'
  | 'editing'
  | 'validating'
  | 'submitting'
  | 'verifying'
  | 'success'
  | 'validation-error'
  | 'request-error'
  | 'request-rejected'
  | 'rate-limited'
  | 'verification-error'
  | 'delivery-error';

export type ContactFieldName = 'name' | 'email' | 'message';

export type ContactFieldErrors = Partial<Record<ContactFieldName, string>>;

export type ContactFormValues = {
  name: string;
  email: string;
  message: string;
  website: string;
};

export const emptyContactValues: ContactFormValues = {
  name: '',
  email: '',
  message: '',
  website: '',
};

export function createSubmissionId() {
  return crypto.randomUUID();
}

export function validateContactValues(values: ContactFormValues): {
  fieldErrors: ContactFieldErrors;
  formError: string | null;
} {
  const parsed = contactPublicFieldSchema.safeParse({
    name: values.name,
    email: values.email,
    message: values.message,
  });

  if (parsed.success) {
    return { fieldErrors: {}, formError: null };
  }

  const fieldErrors: ContactFieldErrors = {};
  for (const issue of parsed.error.issues) {
    const field = issue.path[0];
    if (field === 'name' || field === 'email' || field === 'message') {
      fieldErrors[field] = issue.message;
    }
  }

  return {
    fieldErrors,
    formError: 'Please fix the highlighted fields and try again.',
  };
}

export function isSubmitLocked(phase: ContactPhase) {
  return phase === 'validating' || phase === 'submitting';
}

export function shouldShowRetry(phase: ContactPhase) {
  return (
    phase === 'validation-error' ||
    phase === 'request-error' ||
    phase === 'request-rejected' ||
    phase === 'rate-limited' ||
    phase === 'verification-error' ||
    phase === 'delivery-error'
  );
}

export function shouldShowDirectEmail(phase: ContactPhase) {
  return phase === 'verification-error' || phase === 'delivery-error';
}
